<template>
  <v-navigation-drawer
    :value="isPaymentsConfigOpen"
    :permanent="isPaymentsConfigOpen"
    width="600px"
    max-width="100vw"
    right
    fixed
    temporary
    style="z-index: 11; transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
  >
    <v-card min-height="100vh" color="grey lighten-3">
      <BaseToolbar
        :button-save="true"
        @close="close"
        @save="submitData"
        title="Recurrent Payments"
        type-title="icon"
        icon="edit"
      />
      <v-progress-linear v-if="loading" indeterminate height="5" class="my-0" />
      <v-card-text v-else style="overflow-y: auto; height: calc(100vh - 64px)">
        <v-container class="pa-5">
          <v-row dense justify="center">
            <v-col cols="12" sm="10">
              <v-text-field
                v-model="api_key"
                v-validate="'required'"
                :error-messages="errors.collect('Api Key')"
                label="Api Key"
                data-vv-name="Api Key"
                required
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import BaseToolbar from "@/components/BaseToolbar.vue";

export default {
  name: "DébitoRecurrenteBancario",
  components: {
    BaseToolbar,
  },
  data() {
    return {
      loading: false,
      submitLoading: false,
      api_key: null,
    };
  },
  watch: {
    isPaymentsConfigOpen: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          const isPayments = this.organization.gateways.find(
            ({ gateway }) => gateway.name === "Recurrent Payments"
          );
          this.api_key = isPayments ? isPayments.api_keys.api_key : null;
        }
      },
    }
  },
  computed: {
    ...mapState({
      orgId: ({ organization: { orgId } }) => orgId,
      organization: ({ organization: { organization } }) => organization,
    }),
    ...mapGetters({
      isPaymentsConfigOpen: "organization/isPaymentsConfigOpen",
    }),
  },
  methods: {
    ...mapActions({
      createGateway: "organization/createGateway",
      updatePayments: "organization/updatePayments",
    }),
    ...mapMutations({
      togglePaymentsConfig: "organization/togglePaymentsConfig",
    }),
    close() {
      this.togglePaymentsConfig(false);
      this.cleanData();
    },
    async submitData() {
      const isValid = await this.$validator.validateAll();
      if (isValid) {
        this.submitLoading = true;
        const isPayments = this.organization.gateways.find(
          ({ gateway }) => gateway.name === "Recurrent Payments"
        );
        let response;
        if (isPayments != null) {
          const data = {
            api_keys: {
              api_key: this.api_key,
            },
          };
          response = await this.updatePayments({
            orgId: this.organization.id,
            gatewayId: isPayments.gateway.id,
            data,
          });
        } else {
          const data = {
            gateway_id: 18,
            api_keys: {
              api_key: this.api_key,
            },
          };
          response = await this.createGateway({
            orgId: this.organization.id,
            data,
          });
        }
        this.submitLoading = false;
        if (response) {
          this.close();
        }
      }
    },
    cleanData() {
      this.submitLoading = false;
      this.api_key = null;
      this.$validator.reset();
    },
  },
};
</script>
